import $ from 'jquery';

export function lazyLoadImages() {

  var lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));

  if ("IntersectionObserver" in window) {
    let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
      $.each(entries, function(i, entry) {
        if (entry.isIntersecting) {

          let lazyImage = entry.target;
          lazyImage.src = lazyImage.getAttribute('data-src');
          lazyImage.classList.add('lazyloaded');
          lazyImageObserver.unobserve(lazyImage);
        }
      });
    });

    $.each(lazyImages, function(i, lazyImage) {
      lazyImageObserver.observe(lazyImage);
    });
  } else {
    $.each(lazyImages, function(i, lazyImage) {
      lazyImage.src = lazyImage.getAttribute('data-src');
      lazyImage.classList.add('lazyloaded');
    });
  }
}



// WEBPACK FOOTER //
// ./themes/maisondubillard/_dev/js/components/images.js